import React, {
  MouseEvent, useState,
} from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkAsButton } from '@printdeal/ui-library';
import { SanitizedLineItem } from '../../../../../../types/order/Order';
import { dispatchAccountEvent } from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';
import EditOrderLineItemModal from './EditOrderLineItemModal';

interface EditLineItemButtonProps {
  lineItem: SanitizedLineItem;
  orderId: string;
}

const EditLineItemButton = ({ lineItem, orderId }: EditLineItemButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (event: MouseEvent) => {
    event.preventDefault();
    setIsModalOpen(true);
    dispatchAccountEvent('order_detail_interaction', 'show_edit_full_lineItem');
  };

  return (
    <>
      <LinkAsButton
        type="button"
        onClick={handleOpenModal}
        variant="secondary"
        data-cy="orderEditLineItem"
        iconBefore="edit"
        className="pd-text-xs"
      >
        <FormattedMessage id="lineItems.list.editfull" defaultMessage="Edit selection" />
      </LinkAsButton>
      {isModalOpen && (
        <EditOrderLineItemModal orderId={orderId} lineItem={lineItem} setIsModalOpen={setIsModalOpen} />
      )}
    </>
  );
};

export default EditLineItemButton;
